import Produce from 'immer';

const initial_state ={
    content: {
        code: 'begin var end'
    }
}

export default function lesson( state = initial_state, action){
    return Produce(state, draft =>{
        switch( action.type ){
            case "code/UPDATE":
                draft.content.code = action.payload;
                break;
            default:
        }
    })
}